module.exports = __webpack_public_path__ + "static/media/logo-comjoodoc-easy-lang-color-black.9b8a682f.svg";